import { useEffect, useState } from "react";

// 가로 스트립(정사각 N프레임) 프레임 애니메이션 — 메인 캐릭터용.
// 프레임 수는 이미지 비율(가로/세로)로 자동 판정(월드 걷기 스트립과 동일 규격).
// 시각안전: 저속(기본 2fps < 3Hz), prefers-reduced-motion 이면 1프레임 정지.

interface Props {
  url: string;
  alt: string;
  className?: string;
  fps?: number;
  dataAnim?: string; // 기존 캐릭터 bob 등 CSS 애니와 병행([data-anim] 셀렉터)
}

export function SpriteStrip({ url, alt, className, fps = 2, dataAnim }: Props) {
  const [frames, setFrames] = useState(0);
  const [i, setI] = useState(0);
  const [reduced] = useState(
    () => typeof matchMedia !== "undefined" && matchMedia("(prefers-reduced-motion: reduce)").matches,
  );

  useEffect(() => {
    let alive = true;
    const img = new Image();
    img.onload = () => {
      if (alive) setFrames(Math.max(1, Math.round(img.width / img.height)));
    };
    img.src = url;
    return () => {
      alive = false;
    };
  }, [url]);

  useEffect(() => {
    if (frames < 2 || reduced) return;
    const t = window.setInterval(() => setI((v) => (v + 1) % frames), 1000 / fps);
    return () => window.clearInterval(t);
  }, [frames, fps, reduced]);

  if (frames === 0) return null; // 로드 전(레이아웃 튐 방지 — 부모가 위치 고정)
  return (
    <span
      className={className}
      role="img"
      aria-label={alt}
      data-anim={dataAnim}
      style={{
        display: "block",
        aspectRatio: "1 / 1",
        backgroundImage: `url(${url})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: `${frames * 100}% 100%`,
        backgroundPosition: frames > 1 ? `${(i / (frames - 1)) * 100}% 0` : "0 0",
      }}
    />
  );
}
